import InlineEditors from '../../controllers/inlineEditors';
import Dnd from '../../grid/dnd';

export default instance => {
  instance.attachEvent('onRowDragStart', (id, target, e) => {
    if (InlineEditors.isActive()) {
      InlineEditors.onClick(true);
    }

    return true;
  });

  instance.attachEvent('onRowDragStart', (id, target, e) => Dnd.onRowDragStart(id, target, e));
};
